import { UserProfile } from '@typeDefs/domain/profile';
import { userMapper } from '@services/mappers';
import apiClient from './client';

export const userService = {
  async getProfile(): Promise<UserProfile> {
    const response = await apiClient.api.userProfileList();
    const mappedItems = userMapper.fromApi(response.data);
    return mappedItems;
  },

  // - updateProfile(profileData)
  // - uploadAvatar(file)
  // - getBusinessAccess()
  // - updatePreferences(preferences)
  // - deleteAccount()
};
